exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._29lSX6uSbG-MVNyijkeXvJ{text-overflow:ellipsis;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-item-align:center;align-self:center;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;overflow:hidden;white-space:nowrap}", ""]);
// Exports
exports.locals = {
	"categoriesBaseContainer": "_29lSX6uSbG-MVNyijkeXvJ"
};